export default "__VITE_ASSET__0d2416fc__"